import React from 'react';
import { Route, IndexRoute } from 'react-router';

import AuthorizeRoute from './AuthorizeRoute';

import App from 'containers/AppContainer';
import Login from 'containers/user/LoginContainer';
import ChangePassword from 'containers/user/ChangePasswordContainer';
import Logout from 'components/user/Logout';
import Profile from 'containers/user/ProfileContainer';

import Dashboard from 'containers/dashboard/DashboardContainer';

import GTEstimate from 'containers/gtestimate/GTEstimateContainer';
import MerchantFees from 'containers/fees/FeesContainer';

import AuctionsWrap from 'containers/auctions/AuctionsWrapContainer';
import CurrentAuctions from 'containers/auctions/CurrentAuctionsContainer';
import NewAuctions from 'containers/auctions/NewAuctionsContainer';
import PendingApprovalAuctions from 'containers/auctions/PendingApprovalAuctionsContainer';
import NoOfferAuctions from 'containers/auctions/NoOfferAuctionsContainer';
import ParticipateToAuctions from 'containers/auctions/ParticipateToAuctionsContainer';
import ForSelectionAuctions from 'containers/auctions/ForSelectionAuctionsContainer';
import ForAcceptanceAuctions from 'containers/auctions/ForAcceptanceAuctionsContainer';
import CompletedAuctions from 'containers/auctions/CompletedAuctionsContainer';
import LostAuctions from 'containers/auctions/LostAuctionsContainer';
import RejectedAuctions from 'containers/auctions/RejectedAuctionsContainer';
import Auction from 'containers/auctions/AuctionContainer';
import NewAuction from 'containers/auctions/NewAuctionContainer';
import EditAuction from 'containers/auctions/EditAuctionContainer';
import AuctionDetail from 'containers/auctions/AuctionDetailContainer';

import PartyWrap from 'containers/parties/PartyWrapContainer';
import Party from 'containers/parties/PartyContainer';
import EditParty from 'containers/parties/EditPartyContainer';
import PartiesList from 'containers/parties/PartiesListContainer';

import ForbiddenRouteMatch from './ForbiddenRouteMatch';
import NoRouteMatch from './NoRouteMatch';

const AnyUser = AuthorizeRoute('*');

const Routes = (
  <Route path="/" component={App}>
    <IndexRoute component={Dashboard} onEnter={AnyUser} />

    <Route exact path="/gtestimate" component={GTEstimate} onEnter={AnyUser} />

    <Route exact path="/fees" component={MerchantFees} onEnter={AnyUser} />

    <Route path="/auctions" component={AuctionsWrap} onEnter={AnyUser}>
      <IndexRoute component={CurrentAuctions} />
      <Route
        exact
        path="/auctions/new"
        component={NewAuctions}
        onEnter={AnyUser}
      />
      <Route
        exact
        path="/auctions/pending-approval"
        component={PendingApprovalAuctions}
        onEnter={AnyUser}
      />
      <Route
        exact
        path="/auctions/no-offer"
        component={NoOfferAuctions}
        onEnter={AnyUser}
      />
      <Route
        exact
        path="/auctions/participate-to"
        component={ParticipateToAuctions}
        onEnter={AnyUser}
      />
      <Route
        exact
        path="/auctions/for-selection"
        component={ForSelectionAuctions}
        onEnter={AnyUser}
      />
      <Route
        exact
        path="/auctions/for-acceptance"
        component={ForAcceptanceAuctions}
        onEnter={AnyUser}
      />
      <Route
        exact
        path="/auctions/completed"
        component={CompletedAuctions}
        onEnter={AnyUser}
      />
      <Route
        exact
        path="/auctions/lost"
        component={LostAuctions}
        onEnter={AnyUser}
      />
      <Route
        exact
        path="/auctions/rejected"
        component={RejectedAuctions}
        onEnter={AnyUser}
      />
      <Route
        exact
        path="/auctions/createnew"
        component={NewAuction}
        onEnter={AnyUser}
      />

      <Route path="/auctions/:id" component={Auction} onEnter={AnyUser}>
        <IndexRoute component={AuctionDetail} onEnter={AnyUser} />
        <Route
          path="/auctions/:id/edit"
          component={EditAuction}
          onEnter={AnyUser}
        />
      </Route>
    </Route>

    <Route path="/parties" component={PartyWrap} onEnter={AnyUser}>
      <Route
        exact
        path="/parties/new"
        component={EditParty}
        onEnter={AnyUser}
      />
      <Route exact path="/parties/:id" component={Party} onEnter={AnyUser} />
      <Route path="/parties/:id/edit" component={EditParty} onEnter={AnyUser} />
    </Route>

    <Route
      exact
      path="/all-parties"
      component={PartiesList}
      onEnter={AnyUser}
    />

    <Route path="/login" component={Login} />
    <Route path="/changepassword" component={ChangePassword} />
    <Route path="/userprofile" component={Profile} />
    <Route path="/logout" component={Logout} />
    <Route path="/forbidden" component={ForbiddenRouteMatch} />
    <Route path="*" component={NoRouteMatch} />
  </Route>
);

export default Routes;
